import React, { useEffect } from 'react';
import '@/App.css';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { Toaster } from '@/components/ui/sonner';
import { HomePage } from '@/pages/HomePage';
import { BookingSuccessPage } from '@/pages/BookingSuccessPage';
import { AdminDashboard } from '@/pages/AdminDashboard';
import { CoursePage } from '@/pages/CoursePage';
import { BlogPage, BlogPostPage } from '@/pages/BlogPage';
import { ContactSuccessPage } from '@/pages/ContactSuccessPage';
import { trackPageView } from '@/utils/analytics';

// Track page views on route change
const PageViewTracker = () => {
  const location = useLocation();
  
  useEffect(() => {
    trackPageView(location.pathname + location.search);
  }, [location]);
  
  return null;
};

function App() {
  return (
    <HelmetProvider>
      <div className="App">
        <BrowserRouter>
          <PageViewTracker />
          <Routes>
            {/* Main Pages */}
            <Route path="/" element={<HomePage />} />
            <Route path="/booking-success" element={<BookingSuccessPage />} />
            <Route path="/admin" element={<AdminDashboard />} />
            
            {/* SEO Course Pages */}
            <Route path="/courses/:slug" element={<CoursePage />} />
            
            {/* Blog Pages */}
            <Route path="/blog" element={<BlogPage />} />
            <Route path="/blog/:slug" element={<BlogPostPage />} />
            
            {/* Conversion Pages */}
            <Route path="/contact" element={<HomePage scrollTo="contact" />} />
            <Route path="/book" element={<HomePage scrollTo="courses" />} />
            <Route path="/contact-success" element={<ContactSuccessPage />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-center" />
      </div>
    </HelmetProvider>
  );
}

export default App;
